import { createSlice } from '@reduxjs/toolkit';

const initialState={
    allmeetingspaces:null
}
export const allMeetingSpacesSlice = createSlice({
  name: 'allmeetingspaces',
  initialState,
  reducers: {

    setMeetingSpaces: (state, action) => {
      state.allmeetingspaces = action.payload;
    },
    setLogoutMeetingSpaces: (state,action)=>{
      state.allmeetingspaces=null
    }
  },
});
export const {  setMeetingSpaces,setLogoutMeetingSpaces} = allMeetingSpacesSlice.actions;

export default allMeetingSpacesSlice.reducer;
